import { createStore, applyMiddleware, compose } from 'redux';
import { thunk as ReduxThunk } from 'redux-thunk';
import rootReducer from './redux/rootReducer';

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(ReduxThunk)));

export default store;